import play from '../../../images/play.svg';

const Video = ({link, screenshot, titulo, categoria, id}) =>(
        <>
        <a href={link} className="marquee-card"> 
            <article key={id}>
                <div className="marquee-play-content">
                    <div className="marquee-play">
                        <div><img src={play} /></div>
                    </div> 
                </div>          
                <figure>
                    <img src={screenshot} />
                </figure>
                <div className="marquee-caption">
                    <h4><span>{categoria}</span>{titulo}</h4>
                </div>
            </article>
        </a>
        </>
    )
export default Video;